import { render, staticRenderFns } from "./TopicsWrapper.vue?vue&type=template&id=8d044f92&scoped=true"
import script from "./TopicsWrapper.vue?vue&type=script&lang=js"
export * from "./TopicsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d044f92",
  null
  
)

export default component.exports